import { render } from "./spark-logo.svg?vue&type=template&id=c9a801ae"
const script = {}
script.render = render

export default script